const SORT_KEY = {
  ascend: 'asc',
  descend: 'desc',
  asc: 'asc',
  desc: 'desc',
};

const filterString = ['不限', 'all'];

export const filterReqParams = (arg) => {
  if (arg.method !== 'POST' || !arg.body || arg.body instanceof FormData) {
    return arg;
  }
  const body = {};
  Object.keys(arg.body).forEach(item => {
    if (arg.body[item]) {
      if (arg.body[item] instanceof Array) {
        const list = arg.body[item].filter(it => it && !filterString.includes(it));
        if (list.length) {
          body[item] = list;
        }
      } else {
        body[item] = arg.body[item];
        if (item === 'sort_value') {
          body[item] = SORT_KEY[body[item]];
        }
      }
    }
  });
  return {
    ...arg,
    body,
  };
};
